<template>
    <div>
        <v-card>
            <v-card-title class="blue_corp white--text">
                CREAR PRODUCTO            
                <v-spacer></v-spacer>
                <v-btn @click="d_inventa=true" x-small color="#EDE8D0" rounded>
                    Editar Producto                
                    <v-icon class="ml-2" small>find_replace</v-icon>
                </v-btn>
                <!-- <v-btn fab color="#fe6501" top left x-small>
                    <v-icon class="black--text">edit</v-icon>
                </v-btn> -->
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="8" md="3" class="d-flex">
                                <v-text-field class='mt-n5 text-caption' v-model="sku" :counter="15" label="SKU" :disabled="disabledSku" :filled="filledSku" outlined dense required></v-text-field>
                                <v-btn @click="verSku(sku)" class="ml-2 mt-n3" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                            </v-col>
                            <!-- <v-col cols="4" md="1">
                                <v-btn @click="d_inventa=true" class="mt-n5" small color="indigo" dark rounded><v-icon small>find_replace</v-icon></v-btn>
                            </v-col> -->
                            <v-col cols="12" md="2">
                                <v-alert class='mt-n5 text-caption' v-if="existe=='si'" dense text type="success">
                                    Existe !
                                </v-alert>
                                <v-alert class='mt-n5 text-caption' v-else-if="existe=='no'" dense text type="warning">
                                    Nuevo !
                                </v-alert>
                                <v-alert class='mt-n5 text-caption' v-else dense text type="info">
                                    <span class="text-caption grey--text">Sku: 99999</span>
                                </v-alert>
                            </v-col >
                            <v-col cols="12" md="4">
                                <v-text-field class='mt-n5 text-caption' v-model="nombre" label="Nombre Producto" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                            </v-col>
                            <v-col cols="8" md="3" class="d-flex">
                                <v-select class='mt-n5 text-caption' v-on:change="OpenDialog(categoria)" v-model="categoria" :items="listacategoria" label="Categoria" dense outlined :disabled="disabledResto" :filled="filledResto"></v-select>
                                <v-btn class="ml-2 mt-n4" @click="nuevaCategoria()" icon><v-icon  color="indigo">add_circle_outline</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" md="4">
                                <v-textarea class='mt-n5 text-caption' no-resize rows="6" outlined v-model="descripcion" label="Descripcion" :disabled="disabledResto" :filled="filledResto"></v-textarea>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-row class="mt-0">
                                    <v-col cols="12" md="3">
                                        <v-text-field class='mt-n5 text-caption' v-model="marca" label="Marca" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field class='mt-n5 text-caption' v-model="caracteristica" label="Caracteristica" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-select class='mt-n5 text-caption' v-model="medida" :items="medidas" label="Medida" dense outlined :disabled="disabledResto" :filled="filledResto"></v-select>
                                    </v-col>
                                    <v-col cols="12" md="3" class="d-flex">
                                        <v-text-field class='mt-n5 text-caption' v-model="barra" label="Cod.Barra" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                        <a><v-img v-if="authBarCode=='V'" @click="createBarCode()" class="ml-2 mt-n3" src="@/assets/ico_barra.png" max-height="33" max-width="35"></v-img></a>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' @keypress="onlyNumber" v-model="peso" label="Peso (grs)" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' @keypress="onlyNumber" v-model="volumen" label="Volumen (cm3)" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2" class="text-center">
                                        <h5 class="mt-n2">Precios</h5>
                                        <v-divider class="mx-4"></v-divider>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' @keypress="onlyDecimal" v-model="preciolocal" label="Precio Local" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' @keypress="onlyDecimal" v-model="preciomayor" label="Precio Mayor" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' @keypress="onlyDecimal" v-model="preciooferta" label="Precio Oferta" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <!-- <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' v-model="posicion" label="Posicion" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col> -->
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col cols="12" md="2" class="text-center">
                                        <h5 class="mt-n2">Almacenamiento</h5>
                                        <v-divider class="mx-4"></v-divider>                                       
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' v-model="zona" label="Zona" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' v-model="pasillo" label="Pasillo" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' v-model="estante" label="Estante" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' v-model="nivel" label="Nivel" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field class='mt-n5 text-caption' v-model="posicion" label="Posicion" outlined dense :disabled="disabledResto" :filled="filledResto"></v-text-field>
                                    </v-col>
                                </v-row>                 
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8">
                            <v-col cols="12" md="4">
                                <v-sheet style="border:0.5px solid lightgray" rounded="xl">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="8" md="6">
                                                <h5>Codigos Oem</h5>
                                            </v-col>
                                            <v-col cols="4" md="6" class="text-end">
                                                <v-icon @click="d_codigos=true" color="indigo">add_circle_outline</v-icon>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-sheet>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-sheet style="border:0.5px solid lightgray" rounded="xl">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="8" md="6">
                                                <h5>Vehículos Compatibles</h5>
                                            </v-col>
                                            <v-col cols="4" md="6" class="text-end">
                                                <v-icon @click="d_autos=true" color="indigo">add_circle_outline</v-icon>
                                            </v-col>
                                        </v-row>                                        
                                    </v-container>
                                </v-sheet>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-sheet style="border:0.5px solid lightgray" rounded="xl">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="8" md="6">
                                                <h5>Imagenes del Producto</h5>
                                            </v-col>
                                            <v-col cols="4" md="6" class="text-end">
                                                <v-icon @click="imagen=true" color="indigo">add_circle_outline</v-icon>
                                            </v-col>
                                        </v-row>                                        
                                    </v-container>
                                </v-sheet>
                                <!-- <v-btn class="ml-2" fab small dark @click="imagen=true" color="indigo"><v-icon>photo_library</v-icon></v-btn> -->
                            </v-col>
                        </v-row>
                        <v-row class="mt-5">
                            <v-col cols="12" md="2">
                                <v-text-field @keypress="onlyNumber" v-if="existe=='no'" class='mt-n2 text-caption' v-model="cantidad_stock" label="Stock Inicial" outlined dense clearable></v-text-field>
                                <v-text-field @keypress="onlyNumber" v-else class='mt-n2 text-caption' v-model="cantidad_stock" label="Stock Inicial" outlined dense disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select v-if="existe=='no'" class='mt-n2 text-caption' v-model="bodega" :items="listabodega" label="Bodega" item-text="nombre" item-value="id" dense outlined></v-select>
                                <v-select v-else class='mt-n2 text-caption' label="Bodega" dense outlined disabled filled></v-select>
                            </v-col>
                            <v-col cols="8" md="2">
                                <v-select class='mt-n2 text-caption' label="Estado del Producto" v-model="estado" :items="estados" dense outlined :disabled="disabledResto" :filled="filledResto"></v-select>
                            </v-col>
                            <v-col cols="12" md="2"></v-col>
                            <v-col cols="6" md="2" class="text-end">
                                <v-btn @click="newProducto()" small color="teal" dark rounded block>
                                    <v-icon small>add_circle</v-icon>
                                    <span class='text-btn'>
                                        Nuevo
                                    </span>
                                </v-btn>
                            </v-col>
                            <v-col cols="6" md="2" class="text-end">
                                <v-btn v-if="existe=='no'" @click="createProducto()" small color="teal" dark rounded block>
                                    <v-icon small>save</v-icon>
                                    <span class='text-btn'>
                                        Grabar
                                    </span>
                                </v-btn>
                                <v-btn v-else-if="existe=='si'" @click="modifyProducto()" small color="teal" dark rounded block>
                                    <v-icon small>save</v-icon>
                                    <span class='text-btn'>
                                        Modificar
                                    </span>
                                </v-btn>
                                <v-btn v-else small color="grey" dark rounded block>
                                    <v-icon small>save</v-icon>
                                    <span class='text-btn'>
                                        Grabar
                                    </span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions style="margin-top:-25px">
            </v-card-actions>
        </v-card>
        <!-- DIALOGO NEW CATEGORIA -->
        <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Mantenedor de Categorias</v-toolbar>
            <v-card-text class="mt-5">
                
                <v-row>
                    <v-col cols="12" md="5">
                        <v-text-field class='text-caption' v-model="newcategoria" label="Nueva Categoria" :disabled="disabledCategoria" :filled="filledCategoria" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-alert class='text-caption' v-if="alertacategoria=='si'" dense text type="success">
                            Categoria Creada !!!
                        </v-alert>
                        <v-alert class='text-caption' v-else-if="alertacategoria=='no'" dense text type="error">
                            Sin Categoria !!!
                        </v-alert>
                        <v-alert class='text-caption' v-else dense text type="info">
                            Dato Obligatorio !!!
                        </v-alert>
                    </v-col>
                    <v-col cols="12" md="2">
                        <div v-if="alertacategoria!='si'">
                           <v-btn @click="newCategory()" small fab dark color="indigo"><v-icon>playlist_add</v-icon></v-btn>
                            <!-- <v-btn @click="newCategoria()" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn> -->
                        </div>
                        <div v-else>
                            <v-btn small fab dark color="grey"><v-icon>playlist_add</v-icon></v-btn>
                            <!-- <v-btn small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn> -->
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mt-n8">
                    <v-col cols="12" md="12">
                        <v-data-table dense dark :headers="categoryHead" :items="categoryList" :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event" hide-default-footer class="elevation-1 text-size">
                            <template v-slot:item.accion="{ item }">
                                <v-icon small class="white--text" @click="deleteCategory(item)">delete</v-icon>
                            </template>
                        </v-data-table>
                        <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="CloseDialog()" color="indigo">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- DIALOGO IMAGENES -->
        <v-dialog v-model="imagen" transition="dialog-bottom-transition" max-width="400" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Imagenes del Producto</v-toolbar>
            <v-card-text class="mt-5">
                <v-row>
                    <v-col cols="9" md="9">
                        <v-file-input label="Imagen" dense v-model="archivo" :disabled="disabledResto" :filled="filledResto"></v-file-input>
                    </v-col>
                        <v-col cols="3" md="3">
                            <div class="mt-2">
                            <v-icon color="success" @click="upImagen()">check_circle</v-icon>
                            <v-icon color="red" @click="deleteImagen()">delete</v-icon>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" md="4">
                        <span v-if="fotos.length>0">
                        <v-img :src="fotos[0].src" max-width="55" max-height="55"></v-img>
                        </span>
                        <v-skeleton-loader v-else class="mx-auto" max-width="55" max-height="55" type="card"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="4" md="4">
                        <span v-if="fotos.length>1">
                        <v-img :src="fotos[1].src" max-width="55" max-height="55"></v-img>
                        </span>
                        <v-skeleton-loader v-else class="mx-auto" max-width="55" max-height="55" type="card"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="4" md="4">
                        <span v-if="fotos.length>2">
                        <v-img :src="fotos[2].src" max-width="55" max-height="55"></v-img>
                        </span>
                        <v-skeleton-loader v-else class="mx-auto" max-width="55" max-height="55" type="card"></v-skeleton-loader>
                    </v-col>
                    <!-- <v-col cols="4" md="2">
                        <span v-if="fotos.length>3">
                        <v-img :src="fotos[3].src" max-width="55" max-height="55"></v-img>
                        </span>
                        <v-skeleton-loader v-else class="mx-auto" max-width="55" max-height="55" type="card"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="4" md="2">
                        <span v-if="fotos.length>4">
                        <v-img :src="fotos[4].src" max-width="55" max-height="55"></v-img>
                        </span>
                        <v-skeleton-loader v-else class="mx-auto" max-width="55" max-height="55" type="card"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="4" md="2">
                        <span v-if="fotos.length>5">
                        <v-img :src="fotos[5].src" max-width="55" max-height="55"></v-img>
                        </span>
                        <v-skeleton-loader v-else class="mx-auto" max-width="55" max-height="55" type="card"></v-skeleton-loader>
                    </v-col> -->
                </v-row>                                      
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="imagen=false" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOGO CODIGOS OEM -->
        <v-dialog v-model="d_codigos" transition="dialog-bottom-transition" max-width="600" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Codigos Oem</v-toolbar>
            <v-card-text class="mt-5">                
                <v-row class="mt-7">
                    <v-col cols="12" md="5">
                        <v-text-field class='mt-n5 text-caption' v-model="new_codigo" label="Codigo" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-text-field class='mt-n5 text-caption' v-model="new_proveedor" label="Proveedor" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="text-end">
                        <v-btn class="mt-n7" @click="addCodigo()" small fab dark color="indigo"><v-icon>playlist_add</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="12" md="10">
                        <v-alert class='mt-n5 text-caption' v-if="alertacodigo=='si'" dense text type="success">
                            Codigo Creado !!!
                        </v-alert>
                        <v-alert class='mt-n5 text-caption' v-else-if="alertacodigo=='no'" dense text type="error">
                            Codigo Existe !!!
                        </v-alert>
                        <v-alert class='mt-n5 text-caption' v-else dense text type="info">
                            Datos Obligatorios !!!
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row class="mt-n8">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense>
                            <thead>
                                <tr>
                                    <th id="back" class="text-start">Codigo</th>
                                    <th id="back" class="text-start">Proveedor</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_codigos" :key="item.Codigo">
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Codigo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Proveedor }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon @click="deleteCodigo(item)" color="red" small>delete</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="CloseCodigos()" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    
        <!-- DIALOGO COMPATIBILIDAD VEHICULOS -->
        <v-dialog v-model="d_autos" transition="dialog-bottom-transition" max-width="600" persistent>
            <v-card>
            <v-toolbar color="primary" dark>
                Vehiculos Compatibles
            </v-toolbar>
            <v-card-text class="mt-5">                
                <v-row class="mt-10">
                    <v-col cols="12" md="5">
                        <v-autocomplete class='mt-n8 text-caption' v-model="new_marca" :items="array_marca" item-text='marca' item-value="marca" label="Marca" :search-input.sync="search_marca" @blur="saveCustomMarca" outlined dense required></v-autocomplete>
                        <!-- <v-text-field class='mt-n8 text-caption' v-model="new_marca" label="Marca" outlined dense required></v-text-field> -->
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-autocomplete class='mt-n8 text-caption' v-model="new_modelo" :items="array_modelo" label="Modelo" item-text='modelo' item-value="modelo" :search-input.sync="search_modelo" @blur="saveCustomModelo" outlined dense required></v-autocomplete>
                        <!-- <v-text-field class='mt-n8 text-caption' v-model="new_modelo" label="Modelo" outlined dense required></v-text-field> -->
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-autocomplete @keypress="onlyNumber" class='mt-n8 text-caption' v-model="new_desde" :items="array_desde" label="Año Desde" item-text='desde' item-value="desde" :search-input.sync="search_desde" @blur="saveCustomDesde" outlined dense required></v-autocomplete>
                        <!-- <v-text-field type="number" class='mt-n8 text-caption' v-model="new_desde" label="Año Desde" outlined dense required></v-text-field> -->
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-autocomplete @keypress="onlyNumber" class='mt-n8 text-caption' v-model="new_hasta" :items="array_hasta" label="Año Hasta" item-text='hasta' item-value="hasta" :search-input.sync="search_hasta" @blur="saveCustomHasta" outlined dense required></v-autocomplete>
                        <!-- <v-text-field type="number" class='mt-n8 text-caption' v-model="new_hasta" label="Año Hasta" outlined dense required></v-text-field> -->
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-autocomplete @keypress="onlyDecimal" class='mt-n8 text-caption' v-model="new_cilindro" :items="array_cilindro" label="Cilindrada" item-text='cilindro' item-value="cilindro" :search-input.sync="search_cilindro" @blur="saveCustomCilindro" outlined dense required></v-autocomplete>
                        <!-- <v-text-field type="number" class='mt-n8 text-caption' v-model="new_cilindro" label="Cilindrada" outlined dense required></v-text-field> -->
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn class="mt-n12" @click="addAutos()" small fab dark color="indigo"><v-icon>playlist_add</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="12" md="10">
                        <v-alert class='mt-n5 text-caption' v-if="alertaauto=='si'" dense text type="success">
                            Compatibilidad Creada !!!
                        </v-alert>
                        <v-alert class='mt-n5 text-caption' v-else-if="alertaauto=='no'" dense text type="error">
                            Vehiculo Existe !!!
                        </v-alert>
                        <v-alert class='mt-n5 text-caption' v-else dense text type="info">
                            Datos Obligatorios !!!
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row class="mt-n8">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense>
                            <thead>
                                <tr>
                                    <th id="back" class="text-start">Marca</th>
                                    <th id="back" class="text-start">Modelo</th>
                                    <th id="back" class="text-start">Años</th>
                                    <th id="back" class="text-start">Cilindrada</th>
                                    <th id="back">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_autos" :key="item.id">
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Marca }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Modelo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Desde }} - {{ item.Hasta }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Cilindro }}</span>
                                    </td>
                                    <td class="text-center">
                                        <v-icon @click="deleteAuto(item)" color="red" small>delete</v-icon>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>

                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="CloseAutos()" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- dialog inventa --> 
        <v-dialog v-model="d_inventa" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_inventa=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                <v-spacer>
                    <div class="float-right">
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Producto" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleInventa" dense dark :search="inventasearch" :headers="inventatitulo" :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="inventapage" :length="inventapageCount"  :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>


        <!-- DIALOGO CREAR VEHICULOS   SIN USO  -->  
        <v-dialog v-model="d_vehiculo" transition="dialog-bottom-transition" max-width="600" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Crear Vehiculos</v-toolbar>
            <v-card-text class="mt-5">                
                <v-row class="mt-10">
                    <v-col cols="12" md="5">
                        <v-text-field class='mt-n8 text-caption' v-model="vehiculo_marca" label="Marca" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-text-field class='mt-n8 text-caption' v-model="vehiculo_modelo" label="Modelo" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field type="number" class='mt-n8 text-caption' v-model="vehiculo_desde" label="Año Desde" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field type="number" class='mt-n8 text-caption' v-model="vehiculo_hasta" label="Año Hasta" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field type="number" class='mt-n8 text-caption' v-model="vehiculo_cilindro" label="Cilindrada" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn class="mt-n12" @click="add_Vehiculo()" small fab dark color="indigo">Agregar Vehiculo</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="12" md="10">
                        <v-alert class='mt-n5 text-caption' v-if="alertavehiculo=='si'" dense text type="success">
                            Vehiculo Creado !!!
                        </v-alert>
                        <v-alert class='mt-n5 text-caption' v-else-if="alertavehiculo=='no'" dense text type="error">
                            Vehiculo Existe !!!
                        </v-alert>
                        <v-alert class='mt-n5 text-caption' v-else dense text type="info">
                            Datos Obligatorios !!!
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeVehiculo()" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="d_code" persistent max-width="400">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    <v-icon @click="closeCodeBar()">close</v-icon>
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <div v-if="generateBar==false">
                                <v-progress-circular indeterminate color="red"></v-progress-circular>
                            </div>
                            <img id="barcodeImg" />
                             <!-- <v-img id="barcodeImg" max-height="450" max-width="459"></v-img> -->
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>


        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"/>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
</style>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import axios from 'axios';
import JsBarcode from "jsbarcode";
export default {
    name:'CrearProducto', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            //contrato:'123',
            alertacategoria:'',
            newcategoria:'',
            dialog:false,
            disabledCategoria:false,
            filledCategoria:false,
            disabledResto:true,
            filledResto:true,
            existe:'',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            disabledSku:false,
            filledSku:false,
            sku:'',
            nombre:'',
            categoria:'',
            ncategoria:0,
            listacategoria:[],
            marca:'',
            descripcion:'',
            caracteristica:'',
            preciolocal:'0',
            preciomayor:'0',
            preciooferta:'0',
            critico:'0',
            estados:['V','N'],
            medidas:['UN','KG','LT'],
            estado:'V',
            medida:'UN',
            archivo:'',
            fotos:[],
            imagen:false,
            universal:'',
            barra:0,
            impuesto:0,
            ventaLocal:'',
            ventaMayor:'',
            ventaOferta:'',

            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            categoryHead:[
                { text: 'ID', align: 'center', sortable: false, value: 'id' },
                { text: 'Descripcion', align: 'start', sortable: false, value: 'name' },
                { text: '', align: 'center', sortable: false, value: 'accion' }
            ],
            categoryList:[],
            peso:0,
            volumen:0,

            //codigo Oem
            d_codigos:false,
            new_codigo:'',
            new_proveedor:'',
            alertacodigo:null,
            lista_codigos:[],
            //compatibilidad
            d_autos:false,
            alertaauto:null,
            new_marca:'',
            new_modelo:'',
            new_desde:'',
            new_hasta:'',
            new_cilindro:'',
            lista_autos:[],

            d_inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'iSku', width:'' },
                { text: 'Producto', align: 'start', sortable: true, value: 'iProducto' },
                { text: 'Medida', align: 'start', sortable: true, value: 'iMedida' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 10,

            //vehiculo
            d_vehiculo:false,
            alertavehiculo:null,
            vehiculo_marca:'',
            vehiculo_modelo:'',
            vehiculo_desde:'',
            vehiculo_hasta:'',
            vehiculo_cilindro:'',

            //picking
            zona:'',
            pasillo:'',
            estante:'',
            nivel:'',
            posicion:'',

            //autocomplete
            temp_marcas:[],
            temp_modelos:[],
            temp_desde:[],
            temp_hasta:[],
            temp_cilindro:[],

            array_marca:[],
            array_modelo:[],
            array_desde:[],
            array_hasta:[],
            array_cilindro:[],
            search_marca: null,
            search_modelo: null,
            search_desde: null,
            search_hasta: null,
            search_cilindro: null,

            cantidad_stock:0,
            bodega:0,
            listabodega:[],

            authBarCode:'N',
            d_code:false,
            generateBar:false,
            nClicks:0,

        }
    },
    async mounted(){
        await this.AuthModules();
        await this.SelectCategorias();
        //await this.buscaImpuesto();
        await this.buscarProducto();
        await this.search_autos();
        await this.searchBodegas();
    },
    methods:{
        async AuthModules(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/autoriza_modulos/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        const key = element.Modulo;
                        if(key == "Codigo Barra"){
                            this.authBarCode = element.Estado
                        }
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async createBarCode(){
            if(this.sku!='' && this.sku!= null){
                this.d_code=true;
                const newCode = 'SKU' + this.sku;
                setTimeout(() => {
                    JsBarcode('#barcodeImg', newCode, {
                        //format: 'EAN13 ',
                        lineColor: '#000',
                        width: 1.9,
                        height: 50,
                        displayValue: true
                    });
                    this.barra = newCode;
                    this.generateBar=true;
                }, 2000);
            } else {
                this.Msg='Ingrese Sku del producto';
                this.msgbox=true;
                this.color='error'
                this.showSnack();
            }
        },
        closeCodeBar(){
            document.getElementById( 'barcodeImg' ).src = '';
            this.d_code=false;
            this.generateBar=false;
        },
        async searchBodegas(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+ this.contrato);
                const datos=response.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.listabodega.push({'id':element.ID,'nombre':element.Nombre})
                    });                
                }
            } catch (error) {
                console.log(error)               
            }
        },
        async saveCustomMarca() {
            // Evita que Vuetify borre el texto al perder el foco
            this.$nextTick(() => {
                if (this.search_marca && !this.array_marca.includes(this.search_marca)) {
                    // Agrega el valor nuevo a la lista para que sea válido
                    this.array_marca.push(this.search_marca);
                    this.new_marca = this.search_marca;
                }
            });
            console.log('marca seleccionada', this.search_marca);
            //filtramos el temp_modelos
            const pModelos = this.temp_modelos.filter(res=> res.marca == this.search_marca);
            this.array_modelo = pModelos
        },        
        async saveCustomModelo() {
            // Evita que Vuetify borre el texto al perder el foco
            this.$nextTick(async () => {
                if (this.search_modelo && !this.array_marca.includes(this.search_modelo)) {
                    // Agrega el valor nuevo a la lista para que sea válido
                    this.array_modelo.push(this.search_modelo);
                    this.new_modelo = this.search_modelo;
                    //filtramos desde
                    const pDesde = this.temp_desde.filter(res=> res.marca == this.search_marca && res.modelo == this.search_modelo);
                    this.array_desde = pDesde
                    //filtramos hasta
                    const pHasta = this.temp_hasta.filter(res=> res.marca == this.search_marca && res.modelo == this.search_modelo);
                    this.array_hasta = pHasta
                    //filtramos cilindro
                    const pCilindro = this.temp_cilindro.filter(res=> res.marca == this.search_marca && res.modelo == this.search_modelo);
                    this.array_cilindro = pCilindro
                }
            });
        },        
        async saveCustomDesde() {
            // Evita que Vuetify borre el texto al perder el foco
            this.$nextTick(async () => {
                if (this.search_desde && !this.array_desde.includes(this.search_desde)) {
                    // Agrega el valor nuevo a la lista para que sea válido
                    this.array_desde.push(this.search_desde);
                    this.new_desde = this.search_desde;
                }
            });
        },        
        async saveCustomHasta() {
            // Evita que Vuetify borre el texto al perder el foco
            this.$nextTick(async () => {
                if (this.search_hasta && !this.array_hasta.includes(this.search_hasta)) {
                    // Agrega el valor nuevo a la lista para que sea válido
                    this.array_hasta.push(this.search_hasta);
                    this.new_hasta = this.search_hasta;
                }
            });
        },        
        async saveCustomCilindro() {
            // Evita que Vuetify borre el texto al perder el foco
            this.$nextTick(async () => {
                if (this.search_cilindro && !this.array_cilindro.includes(this.search_cilindro)) {
                    // Agrega el valor nuevo a la lista para que sea válido
                    this.array_cilindro.push(this.search_cilindro);
                    this.new_cilindro = this.search_cilindro;
                }
            });
        },        
        async search_autos(){
            try {
                this.temp_marcas=[];
                this.temp_modelos=[];
                this.temp_desde=[];
                this.temp_hasta=[];
                this.temp_cilindro=[];
                const params = this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/autos/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        //marcas
                        if(this.temp_marcas.length!=0){
                            const found = this.temp_marcas.filter(res => res.marca == element.Marca);
                            if(found.length==0){
                                this.temp_marcas.push({
                                    'marca': element.Marca
                                });
                            }
                        } else {
                            this.temp_marcas.push({
                                'marca': element.Marca
                            });
                        };
                        //modelos
                        if(this.temp_modelos.length!=0){
                            const found = this.temp_modelos.filter(res => res.marca == element.Marca && res.modelo == element.Modelo);
                            if(found.length==0){
                                this.temp_modelos.push({
                                    'marca': element.Marca,
                                    'modelo': element.Modelo
                                });
                            }
                        } else {
                            this.temp_modelos.push({
                                'marca': element.Marca,
                                'modelo': element.Modelo
                            });
                        };
                        //año desde
                        if(this.temp_desde.length!=0){
                            const found = this.temp_desde.filter(res => res.marca == element.Marca && res.modelo == element.Modelo && res.desde == element.Desde);
                            if(found.length==0){
                                this.temp_desde.push({
                                    'marca': element.Marca,
                                    'modelo': element.Modelo,
                                    'desde': element.Desde
                                });
                            }
                        } else {
                            this.temp_desde.push({
                                'marca': element.Marca,
                                'modelo': element.Modelo,
                                'desde': element.Desde
                            });
                        };
                        //año hasta
                        if(this.temp_hasta.length!=0){
                            const found = this.temp_hasta.filter(res => res.marca == element.Marca && res.modelo == element.Modelo && res.hasta == element.Hasta);
                            if(found.length==0){
                                this.temp_hasta.push({
                                    'marca': element.Marca,
                                    'modelo': element.Modelo,
                                    'hasta': element.Hasta
                                });
                            }
                        } else {
                            this.temp_hasta.push({
                                'marca': element.Marca,
                                'modelo': element.Modelo,
                                'hasta': element.Hasta
                            });
                        };
                        //año cilindro
                        if(this.temp_cilindro.length!=0){
                            const found = this.temp_cilindro.filter(res => res.marca == element.Marca && res.modelo == element.Modelo && res.cilindro == element.Cilindro);
                            if(found.length==0){
                                this.temp_cilindro.push({
                                    'marca': element.Marca,
                                    'modelo': element.Modelo,
                                    'cilindro': element.Cilindro
                                });
                            }
                        } else {
                            this.temp_cilindro.push({
                                'marca': element.Marca,
                                'modelo': element.Modelo,
                                'cilindro': element.Cilindro
                            });
                        };
                    });
                    // solo asignamos las marcas
                    this.array_marca = this.temp_marcas;
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async closeVehiculo(){
            this.d_vehiculo=false
        },
        async buscarProducto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
            const datos=response.data;
            this.inventalista=[];
            if (datos[0].existe=='si'){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    this.inventalista.push({
                        'iSku':element.Sku,
                        'iProducto':element.Nombre,
                    });
                }
            }
        },
        handleInventa(line){
            this.verSku(line.iSku);
            this.d_inventa=false
        },
        async saveCodigos(){
            let result = false;
            try {
                const params={
                    'contrato': this.contrato,
                    'sku': this.sku,
                    'codigo': this.new_codigo,
                    'proveedor': this.new_proveedor,
                };
                const response = await axios.post(process.env.VUE_APP_URL + '/api/control/codigos/', params);
                const datos=response.data;
                if(datos=='si'){
                    await this.getCodigos();
                    result = true
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async getCodigos(){
            this.lista_codigos=[];
            try {
                const params = this.sku + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/codigos/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.lista_codigos = datos
                }  
            } catch (error) {
                console.log(error)
            }
        },
        async addCodigo(){
            if(this.new_codigo!=null){
                if(this.new_codigo!=''){
                    //verificar si el codigo ya existe
                    let verify=false;
                    if(this.lista_codigos.length!=0){
                        const verifyCode = this.lista_codigos.filter(res => res.Codigo == this.new_codigo);
                        if(verifyCode.length!=0){
                            verify=true;
                        }
                    };
                    if(!verify){
                        const codigo_grabado = await this.saveCodigos();
                        if(codigo_grabado==true){
                            this.new_codigo='';
                            this.new_proveedor='';
                            this.alertacodigo='si';
                            setTimeout(() => { this.alertacodigo=null }, 3000);
                        } else {
                            this.Msg='Codigo NO grabado, intentelo nuevamente';
                            this.msgbox=true;
                            this.color='red'
                            this.showSnack();
                        }
                    } else {
                        this.alertacodigo='no';
                        setTimeout(() => { this.alertacodigo=null }, 3000);
                    }
                }
            }
        },
        async deleteCodigo(fila){
            // this.lista_codigos = this.lista_codigos.filter(function(dat) {
            //     return dat.code !== fila.code; 
            // });
            try {
                const params = fila.ID + '/' + this.contrato;
                const response = await axios.delete(process.env.VUE_APP_URL + '/api/control/codigos/delete/' + params);
                const datos=response.data;
                if(datos=='si'){
                    await this.getCodigos();
                } else {
                    this.Msg='Codigo NO eliminado, intentelo nuevamente';
                    this.msgbox=true;
                    this.color='red'
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            }
            this.new_codigo='';
            this.new_proveedor='';
            this.alertacodigo=null;
        },
        CloseCodigos(){
            this.new_codigo='';
            this.new_proveedor='';
            this.alertacodigo=null;
            this.d_codigos=false;
        },
        async saveAutos(){
            let result = false;
            try {
                const params={
                    'contrato': this.contrato,
                    'sku': this.sku,
                    'marca': this.new_marca.toUpperCase(),
                    'modelo': this.new_modelo.toUpperCase(),
                    'desde': this.new_desde,
                    'hasta': this.new_hasta,
                    'cilindro': this.new_cilindro,
                };
                const response = await axios.post(process.env.VUE_APP_URL + '/api/control/Compatibles/', params);
                const datos=response.data;
                if(datos=='si'){
                    await this.getAutos();
                    result = true
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async getAutos(){
            this.lista_autos=[];
            try {
                const params = this.sku + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/Compatibles/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.lista_autos = datos
                }  
            } catch (error) {
                console.log(error)
            }
        },
        async addAutos(){
            if(this.new_marca!=null){
                if(this.new_marca!=''){
                    //verificar si en la lista ya existe
                    let verify=false;
                    if(this.lista_autos.length!=0){
                        const verifyCode = this.lista_autos.filter(res => res.Marca == this.new_marca && res.Modelo == this.new_modelo);
                        if(verifyCode.length!=0){
                            verify=true;
                        }
                    };
                    if(!verify){
                        if(this.sku!=null && this.sku!=''){
                            const auto_grabado = await this.saveAutos();
                            if(auto_grabado==true){
                                this.new_marca='';
                                this.new_modelo='';
                                this.new_desde='';
                                this.new_hasta='';
                                this.new_cilindro='';
                                this.alertaauto='si';
                                setTimeout(() => { this.alertaauto=null }, 3000);
                            } else {
                                this.Msg='Vehiculo NO grabado, intentelo nuevamente';
                                this.msgbox=true;
                                this.color='red'
                                this.showSnack();
                            }
                        } else {
                            this.Msg='Ingrese Sku para continuar';
                            this.msgbox=true;
                            this.color='red'
                            this.showSnack();
                        }
                    } else {
                        this.alertaauto='no';
                        setTimeout(() => { this.alertaauto=null }, 3000);
                    }
                }
            }
        },
        async deleteAuto(fila){
            // this.lista_autos = this.lista_autos.filter(function(dat) {
            //     return dat.marca !== fila.marca; 
            // });
            try {
                const params = fila.ID + '/' + this.contrato;
                const response = await axios.delete(process.env.VUE_APP_URL + '/api/control/Compatibles/delete/' + params);
                const datos=response.data;
                if(datos=='si'){
                    await this.getAutos();
                } else {
                    this.Msg='Vehiculo NO eliminado, intentelo nuevamente';
                    this.msgbox=true;
                    this.color='red'
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            };
            this.new_marca='';
            this.new_modelo='';
            this.new_desde='';
            this.new_hasta='';
            this.new_cilindro='';
            this.alertaauto=null;
        },
        CloseAutos(){
            this.new_marca='';
            this.new_modelo='';
            this.new_desde='';
            this.new_hasta='';
            this.new_cilindro='';
            this.alertaauto=null;
            this.d_autos=false;
        },
        async createProducto(){
            this.loading=true;
            console.log(this.ncategoria);
            if(this.existe=='no'){ //nuevo
                if(parseInt(this.ncategoria)!=0){
                    this.nClicks ++;
                    if(parseInt(this.nClicks)==1){
                        try {
                            const parametros={
                                'contrato': this.contrato,
                                'sku': this.sku,
                                'nombre': this.nombre,
                                'categoria': this.ncategoria,
                                'descripcion': this.descripcion,
                                'marca': this.marca,
                                'caracteristica': this.caracteristica,
                                'preciolocal': this.preciolocal,
                                'preciomayor': this.preciomayor,
                                'preciooferta': this.preciooferta,
                                'critico': this.critico,
                                'universal': this.universal,
                                'barra':this.barra,
                                'estado': this.estado,
                                'medida':this.medida,
                                'peso':this.peso,
                                'volumen':this.volumen,
                                'zona': this.zona,
                                'pasillo': this.pasillo,
                                'estante': this.estante,
                                'nivel': this.nivel,
                                'posicion':this.posicion,
                            };
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/producto/nuevo/v3/',parametros);
                            const datos=response.data;
                            if(datos=='si'){ 
                                await this.stock_inicial();
                                this.Msg='Producto grabado con existo'
                                this.msgbox=true;
                                this.color='success';
                                this.showSnack();
                            } else {
                                this.Msg='Producto NO grabado, intentelo nuevamente'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }                   
                        } catch (error) {
                            console.log(error)
                        }                        
                    }
                } else {
                    this.Msg='Ingrese Categoria del producto';
                    this.msgbox=true;
                    this.color='red'
                    this.showSnack();
                }
            } else {
                this.Msg='Ingrese Sku del producto';
                this.msgbox=true;
                this.color='red'
                this.showSnack();
            }
            this.loading=false;
        },
        async modifyProducto(){
            this.loading=true;
            if(this.existe=='si'){ //modifica
                try {
                    const parametros={
                        'contrato': this.contrato,
                        'sku': this.sku,
                        'nombre': this.nombre,
                        'categoria': this.ncategoria,
                        'descripcion': this.descripcion,
                        'marca': this.marca,
                        'caracteristica': this.caracteristica,
                        'preciolocal': this.preciolocal,
                        'preciomayor': this.preciomayor,
                        'preciooferta': this.preciooferta,
                        'critico': this.critico,
                        'universal': this.universal,
                        'barra':this.barra,
                        'estado': this.estado,
                        'medida':this.medida,
                        'peso':this.peso,
                        'volumen':this.volumen,
                        'zona': this.zona,
                        'pasillo': this.pasillo,
                        'estante': this.estante,
                        'nivel': this.nivel,
                        'posicion':this.posicion,
                    };
                    const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/producto/actualiza/v3/'+ this.sku, parametros);
                    const datos=response.data;
                    if(datos=='si'){ 
                        this.Msg='Producto modificado con existo'
                        this.msgbox=true;
                        this.color='success';
                        this.showSnack();
                    } else {
                        this.Msg='Producto NO modificado, intentelo nuevamente'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }                   
                } catch (error) {
                    console.log(error)
                }                    
            } else {
                this.Msg='Ingrese Sku del producto';
                this.msgbox=true;
                this.color='red'
                this.showSnack();
            }
            this.loading=false;
        },






        async buscaImpuesto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/impuesto/'+this.contrato);
            const datos=response.data;
            this.impuesto=0;
            if (datos[0].existe=='si'){
                this.impuesto=datos[0].Iva
            }
        },
        restoDisabled(bool){
            this.disabledResto=bool,
            this.filledResto=bool
        },
        onlyNumber ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        onlyDecimal ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },

        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        async SelectCategorias(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/categorias/'+ this.contrato);
            const datos=response.data;
            this.listacategoria=[];
            this.categoryList=[];
            //this.listacategoria.push('Nueva');
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    this.listacategoria.push(element.Nombre);
                    this.categoryList.push({'id':element.ID,'name':element.Nombre});
                });
            }
        },
        async numeroCategoria(txtcategoria){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/categorias/'+ this.contrato);
            const datos=response.data;
            //console.log('2');
            datos.forEach(element => {
                if(element.Nombre==txtcategoria){
                    this.ncategoria=element.ID
                }
            });
            //console.log(this.ncategoria)
        },
        async nombreCategoria(numeroCategoria){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/categorias/'+ this.contrato);
            const datos=response.data;
            //console.log('3');
            datos.forEach(element => {
                if(element.ID==numeroCategoria){
                    this.categoria=element.Nombre
                }
            });
            //console.log(this.categoria)
        },        
        OpenDialog(a) {
            this.alertacategoria='';
            this.newcategoria='';
            this.dialog=false;
            //console.log(a);
            this.numeroCategoria(a);
        },
        nuevaCategoria(){
            this.dialog=true;
            this.alertacategoria='';
            this.newcategoria='';
        },
        async deleteCategory(item){
            try {
                //validar que la categoria no tenga productos
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/categorias/verify/products/'+this.contrato+'/'+item.id);
                const datos=response.data;
                //console.log(datos);
                if(datos[0].existe=='si'){
                    this.Msg='Categoria con Productos vigentes';
                    this.msgbox=true;
                    this.color='red'
                    this.showSnack();
                } else {
                    if(datos[0].existe=='no'){
                        //eliminar la bodega
                        const res = await axios.delete(process.env.VUE_APP_URL + '/api/inv/categorias/delete/'+ this.contrato+'/'+item.id);
                        const dat=res.data;
                        if(dat=='ok'){
                            await this.SelectCategorias();
                            // this.categoryList = this.categoryList.filter(function(reg) {
                            //     return reg.id !== item.id; 
                            // });
                            // console.log('categoria eliminado');
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        CloseDialog() {
           if(this.newcategoria!='' && this.alertacategoria=='si'){
                this.categoria=this.newcategoria;
                this.numeroCategoria(this.categoria);
            };
            this.newcategoria='';
            this.alertacategoria='';
            this.disabledCategoria=false;
            this.filledCategoria=false;
            this.dialog=false;
        },
        async newCategory(){
            try {
                if(this.newcategoria!=''){
                    this.disabledCategoria=true;
                    this.filledCategoria=true;
                    var parametros={
                        'contrato': this.contrato,
                        'nombre': this.newcategoria};
                    const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/categorias/nueva',parametros);
                    const datos=response.data;
                    if (datos=='si'){
                        await this.SelectCategorias();
                        // this.listacategoria.push(this.newcategoria);
                        this.categoria=this.newcategoria;
                        this.alertacategoria='si';                
                    }
                } else {
                    this.alertacategoria='no';
                }                
            } catch (error) {
                console.log(error)
            }
        },
        clsInput(){
            this.nombre='';
            this.categoria='';
            this.ncategoria=0;
            this.descripcion='';
            this.marca='';
            this.caracteristica='';
            this.preciolocal='0';
            this.preciomayor='0';
            this.preciooferta='0';
            this.critico='0';
            this.estado='V';
            this.medida='UN'
            this.fotos=[];
            this.archivo='';
            this.universal='';
            this.barra=0;
            this.ventaLocal='';
            this.ventaMayor='';
            this.ventaOferta='';
            this.peso=0;
            this.volumen=0;
            this.lista_codigos=[];
            this.lista_autos=[];
            this.zona='';
            this.pasillo='';
            this.estante='';
            this.nivel='';
            this.posicion='';
            this.cantidad_stock=0;
            this.nClicks=0;
        },
        async verSku(xSku){
             this.loading=true;
             this.msgbox=false;
             this.clsInput();
            if(xSku.trim()!=''){
                this.sku=this.sku.toUpperCase();
                xSku=xSku.toUpperCase();
                this.disabledSku=true;
                this.filledSku=true;                
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/producto/'+this.contrato+'/'+xSku);
                const datos=response.data;
                //console.log(datos);
                if (datos[0].existe=='no'){
                    this.existe='no';
                    this.restoDisabled(false);
                }
                if (datos[0].existe=='error'){
                    this.Msg='Conexion Inestable, intentelo mas tarde'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                    this.newProducto()
                }
                if (datos[0].existe=='si'){               
                    this.existe='si';
                    this.sku=datos[0].Sku;
                    this.nombre=datos[0].Nombre;
                    this.ncategoria=datos[0].Categoria;
                    this.descripcion=datos[0].Descripcion;
                    this.marca=datos[0].Marca;
                    this.caracteristica=datos[0].Caracteristica;
                    this.preciolocal=datos[0].PrecioLocal;
                    this.ventaLocal=parseFloat(this.preciolocal)+Math.round((parseFloat(this.preciolocal)*parseFloat(this.impuesto)/100));
                    //this.ventaLocal="Venta: "+new Intl.NumberFormat("de-DE").format(parseFloat(this.ventaLocal));
                    this.ventaLocal="Venta: "+this.ventaLocal;
                    this.preciomayor=datos[0].PrecioMayor;
                    this.ventaMayor=parseFloat(this.preciomayor)+Math.round((parseFloat(this.preciomayor)*parseFloat(this.impuesto)/100));
                    this.ventaMayor="Venta: "+this.ventaMayor;
                    this.preciooferta=datos[0].PrecioOferta;
                    this.ventaOferta=parseFloat(this.preciooferta)+Math.round((parseFloat(this.preciooferta)*parseFloat(this.impuesto)/100));
                    this.ventaOferta="Venta: "+this.ventaOferta;
                    this.critico=datos[0].Critico;
                    this.universal=datos[0].Universal;
                    this.barra=datos[0].Barra;
                    this.estado=datos[0].Estado;
                    this.medida=datos[0].Medida;
                    this.peso=datos[0].Peso;
                    this.volumen=datos[0].Volumen;
                    this.zona=datos[0].Zona;
                    this.pasillo=datos[0].Pasillo;
                    this.estante=datos[0].Estante;
                    this.nivel=datos[0].Nivel;
                    this.posicion=datos[0].Posicion;
                    await this.nombreCategoria(this.ncategoria);
                    await this.getCodigos();
                    await this.getAutos();
                    await this.verImagen();
                    this.restoDisabled(false);
                } 
            } else {
                this.existe=''
            }
            this.loading=false;
        },
        async verImagen(){
            this.fotos=[];
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/producto/imagen/'+this.contrato+'/'+this.sku);
            const res= response.data;
            if (res[0].existe=='si'){
                res.forEach(element => {
                    this.fotos.push({src:element.Imagen});
                });
            }
        },
        // async saveProducto(){
        //      this.loading=true;
        //      this.msgbox=false;
        //      console.log(
        //         this.contrato,
        //         this.ncategoria,
        //         this.sku,
        //         this.nombre,
        //         this.categoria,
        //         this.descripcion,
        //         this.preciolocal,
        //         this.peso,
        //         this.volumen
        //      )
        //     if (this.contrato!='' && parseInt(this.ncategoria)!=0 &&
        //         this.sku!='' && this.nombre!='' && this.categoria!='' && this.preciolocal!=''){                
        //         this.ventaLocal=parseFloat(this.preciolocal)+Math.round((parseFloat(this.preciolocal)*parseFloat(this.impuesto)/100));
        //         this.ventaLocal="Venta: "+this.ventaLocal;
        //         this.ventaMayor=parseFloat(this.preciomayor)+Math.round((parseFloat(this.preciomayor)*parseFloat(this.impuesto)/100));
        //         this.ventaMayor="Venta: "+this.ventaMayor;
        //         this.ventaOferta=parseFloat(this.preciooferta)+Math.round((parseFloat(this.preciooferta)*parseFloat(this.impuesto)/100));
        //         this.ventaOferta="Venta: "+this.ventaOferta;
        //         var parametros={
        //             'contrato': this.contrato,
        //             'sku': this.sku,
        //             'nombre': this.nombre,
        //             'categoria': this.ncategoria,
        //             'descripcion': this.descripcion,
        //             'marca': this.marca,
        //             'caracteristica': this.caracteristica,
        //             'preciolocal': this.preciolocal,
        //             'preciomayor': this.preciomayor,
        //             'preciooferta': this.preciooferta,
        //             'critico': this.critico,
        //             'universal': this.universal,
        //             'barra':this.barra,
        //             'estado': this.estado,
        //             'medida':this.medida,
        //             'peso':this.peso,
        //             'volumen':this.volumen,
        //         };
        //         if (this.existe=='si'){
        //             // actualizar
        //             const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/producto/actualiza/v3/'+this.sku,parametros);
        //             const datos=response.data;
        //             //console.log(datos);
        //             if (datos=='si'){                
        //                 this.Msg='Modificacion de producto Existoso !!!'
        //                 this.msgbox=true;
        //                 this.color='success'
        //                 this.showSnack();
        //             } 
        //             if (datos=='error'){
        //                 this.Msg='Conexion Inestable, intentelo mas tarde'
        //                 this.msgbox=true;
        //                 this.color='red';
        //                 this.showSnack();
        //                 this.newProducto()
        //             }
        //         }
        //         if (this.existe=='no'){
        //             // ingresar                    
        //             const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/producto/nuevo/v3',parametros);
        //             const datos=response.data;
        //             console.log(datos);
        //             if (datos=='si'){ 
        //                 await this.stock_inicial();
        //                 this.existe='si';               
        //                 this.Msg='Nuevo Producto Existoso !!!'
        //                 this.msgbox=true;
        //                 this.color='success';
        //                 this.showSnack();
        //             } 
        //             if (datos=='error'){
        //                 this.Msg='Conexion Inestable, intentelo mas tarde'
        //                 this.msgbox=true;
        //                 this.color='red';
        //                 this.showSnack();
        //                 this.newProducto()
        //             }
        //         }
        //     } else {
        //             this.Msg='Todos los datos obligatorios';
        //             this.msgbox=true;
        //             this.color='info';
        //             this.showSnack();
        //     }
        //     this.loading=false;
        // },
        async stock_inicial(){
            //buscar todas las bodegas del sistema
            try {
                if(this.cantidad_stock==null){ this.cantidad_stock = 0 };
                if(this.cantidad_stock==''){ this.cantidad_stock = 0 };
                const response0 = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+this.contrato);
                const datos0=response0.data;
                if (datos0[0].existe=='si'){
                    for (let index = 0; index < datos0.length; index++) {
                        const element = datos0[index];
                        let nCantidad = 0
                        if(parseInt(this.bodega) == parseInt(element.ID)){
                            nCantidad = this.cantidad_stock
                        };
                        // agregamos el stock a las sucursales
                        var parametros1={
                            'contrato': this.contrato,
                            'sku': this.sku,
                            'cantidad': nCantidad,
                            'signo': '0+',
                            'bodega': element.ID,
                            'usuario': this.usu,
                            'observa': 'Producto Creado',
                            'origen':'Ingreso'};
                        const response1 = await axios.post(process.env.VUE_APP_URL + '/api/inv/stock',parametros1);
                        const datos1=response1.data;
                        if (datos1=='si'){ 
                            console.log('stock creado');
                        } else {
                            console.log('sin stock');
                        }
                    }
                }                
            } catch (error) {
                console.log(error)
            }
        },
        newProducto(){
            this.loading=true;
            this.msgbox=false;
            this.sku='';
            this.clsInput();
            this.disabledSku=false;
            this.filledSku=false;
            this.restoDisabled(true);
            this.existe='';
            this.loading=false;
        },
        async saveImagen(nameArchivo){
            const rutaImagen=process.env.VUE_APP_URL + '/images/'+this.contrato+'/'+nameArchivo
            var parametros={
                'contrato': this.contrato,
                'sku': this.sku,
                'ruta': rutaImagen};
            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/producto/imagen',parametros);
            //console.log(response.data);
            if(response.data=='si') {
                this.fotos.push({src:rutaImagen});
                this.Msg='Archivo Ok';
                this.color='success';
                this.msgbox=true;
                this.showSnack();
            } else {
                this.Msg='No se grabo imagen';
                this.color='red';
                this.msgbox=true;
                this.showSnack();                    
            }
        },
        async upImagen(){
            if (this.sku.trim()!=''){
                if(this.fotos.length<6){
                    this.loading=true;
                    if (this.archivo!=''){
                        let InstFormData = new FormData();
                        InstFormData.append('archivo' , this.archivo);
                        InstFormData.append('contrato' , this.contrato);
                        const response= await axios.post(process.env.VUE_APP_URL + '/api/server/FileUp', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                        if (response.data=='ok'){
                            await this.saveImagen(this.archivo.name);
                        }
                        if (response.data=='no'){
                            this.Msg='Archivo no permitido';
                            this.color='info';
                            this.msgbox=true;
                            this.showSnack();                    
                        }
                        if (response.data=='error'){
                            this.Msg='No se guardo Imagen';
                            this.color='red';
                            this.msgbox=true;
                            this.showSnack();                    
                        }
                    } else {
                        this.Msg='Debe seleccionar archivo';
                        this.msgbox=true;
                        this.color='info';
                        this.showSnack();                    
                    }
                    this.loading=false;
                } else {
                    console.log('No Mas');
                }
            } else {
                this.Msg='Ingrese Sku';
                this.msgbox=true;
                this.color='info';
                this.showSnack();                    
            }
        },
        async deleteImagen(){
            this.loading=true;
            if (this.fotos.length>0){
                const response = await axios.delete(process.env.VUE_APP_URL + '/api/inv/producto/imagen/delete/'+this.contrato+'/'+this.sku);
                //console.log(response.data);
                if (response.data=='ok'){
                    // this.Msg='Eliminacion Ok';
                    // this.color='success';
                    // this.msgbox=true;
                    // this.showSnack();
                    await this.verImagen()                    
                }
            }
            this.loading=false;
        }
    }
}
</script>
